import { createSlice } from "@reduxjs/toolkit";

const orderSlice = createSlice({
  name: "order",
  initialState: {
    orderId: null,
    credits: 0,
    orderAmount: 0,
  },
  reducers: {
    setOrderDetails: (state, action) => {
      state.orderId = action.payload.orderId;
      state.orderAmount = action.payload.orderAmount;
      state.credits = action.payload.credits;
    },
    clearOrderDetails: (state) => {
      state.orderId = null;
      state.orderAmount = 0;
      state.credits = 0;
    },
  },
});

export const { setOrderDetails, clearOrderDetails } = orderSlice.actions;
export const selectOrder = (state) => state.order;
export default orderSlice.reducer;
